// dashboard.component.ts
import { Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { BadgeModule } from 'primeng/badge';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonModule } from 'primeng/button';
import { MetabaseService } from '../shared/services/metabase.service';
import { ThemeService } from '../shared/services/theme.service';

interface Activity {
  id: number;
  type: string;
  description: string;
  timestamp: string;
  status: string;
}

interface Staff {
  name: string;
  status: string;
  cases: number;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: true,
  imports: [CommonModule, CardModule, TableModule, TagModule, BadgeModule, ProgressSpinnerModule, ButtonModule]
})
export class DashboardComponent {
  private metabaseService = inject(MetabaseService);
  private sanitizer = inject(DomSanitizer);
  private themeService = inject(ThemeService);

  activities: Activity[] = [
    { id: 1, type: 'Emergency', description: 'Medical assistance required at 123 Oak St', timestamp: '2 min ago', status: 'active' },
    { id: 2, type: 'General', description: 'Routine check-in completed', timestamp: '15 min ago', status: 'completed' },
    { id: 3, type: 'Alert', description: 'Fall detection alarm triggered', timestamp: '1 hour ago', status: 'resolved' }
  ];

  staff: Staff[] = [
    { name: 'John Doe', status: 'available', cases: 2 },
    { name: 'Jane Smith', status: 'busy', cases: 4 },
    { name: 'Mike Johnson', status: 'offline', cases: 0 }
  ];

  stats = {
    activeCalls: 5,
    waitingCalls: 2,
    resolvedToday: 15,
    criticalCases: 1
  };

  // Metabase iframe properties
  iframeUrl: SafeResourceUrl | null = null;
  loading = true;
  error: string | null = null;

  // Configure your Metabase dashboard ID here
  // Change this to your actual Metabase dashboard ID (e.g., 27)
  private readonly METABASE_DASHBOARD_ID = 27;

  private readonly themeEffect = effect(() => {
    const isDarkMode = this.themeService.isDarkMode();
    this.loadMetabaseEmbed(isDarkMode);
  });

  /**
   * Load Metabase embedded dashboard URL from backend
   */
  loadMetabaseEmbed(isDarkMode: boolean = this.themeService.isDarkMode()) {
    this.loading = true;
    this.error = null;

    this.metabaseService
      .getDashboardUrl(this.METABASE_DASHBOARD_ID, 10, isDarkMode)
      .subscribe({
      next: (response) => {
        // Sanitize the URL for iframe use
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response.iframe_url);
        this.loading = false;
      },
      error: (err) => {
        console.error('Failed to load Metabase embed:', err);
        this.error = 'Failed to load dashboard. Please try again later.';
        this.loading = false;
      }
    });
  }

  // getStatusSeverity(status: string): string {
  //   switch (status) {
  //     case 'active': return 'danger';
  //     case 'completed': return 'success';
  //     case 'resolved': return 'info';
  //     default: return 'warning';
  //   }
  // }

  // getStaffStatusSeverity(status: string): PRIME_SEVERITY {
  //   switch (status) {
  //     case 'available': return 'success';
  //     case 'busy': return 'warn';
  //     case 'offline': return 'danger';
  //     default: return 'info';
  //   }
  // }
}
